
import Vue from "vue";
import draggable from "vuedraggable";
import { AssessmentQuestion } from "@/interfaces/recruiter/candidates/create_assessment";

export default Vue.extend({
  name: "QuestionsSection",
  components: {
    draggable
  },
  props: {
    questions: {
      type: Array as () => AssessmentQuestion[],
      default: () => []
    },
    questionTypes: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localQuestions: [...this.questions]
    };
  },
  watch: {
    questions: {
      handler(newQuestions) {
        this.localQuestions = [...newQuestions];
      },
      deep: true
    }
  },
  methods: {
    onDragEnd() {
      this.$emit("reorder-questions", this.localQuestions);
    },
    getQuestionTypeKey(type: string): string {
      const map: { [key: string]: string } = {
        mcq: "multiple_choice",
        true_false: "true_false",
        short_answer: "short_answer"
      };
      return map[type] || "custom";
    },
    getQuestionStatusText(isEnabled: boolean): string {
      return (
        (this.$t(
          isEnabled
            ? "recruiter.assessments.questions_section.enabled"
            : "recruiter.assessments.questions_section.disabled"
        ) as string) || ""
      );
    },
    getQuestionTypeColor(type: string): string {
      const colorMap: { [key: string]: string } = {
        mcq: "primary",
        true_false: "primary",
        short_answer: "primary"
      };
      return colorMap[type] || "grey";
    }
  }
});
